import { Activity, ActivityModel, ScreenActivity } from './activity';

export class CompleteActivityReasons {
  static COMPLETED = 'Completed';
  static REJECTED = 'Rejected';
  static INCOMPLETE = 'Incomplete';

  static ALL_REASONS = [
    this.COMPLETED,
    this.REJECTED,
    this.INCOMPLETE
  ];
}

export class CompleteWorkflowActivityModel extends ActivityModel {
  reason: string;
  activities: Activity<ActivityModel>[];
  autoSubmit: boolean;

  constructor(options?: Partial<CompleteWorkflowActivityModel>) {
    super(options);

    this.reason = CompleteActivityReasons.COMPLETED;
    this.autoSubmit = false;
    this.screenName = 'End';

    if (options) {
      Object.assign(this, options);
    }
  }
}

export class CompleteWorkflowActivity extends ScreenActivity<
  CompleteWorkflowActivityModel
> {
  constructor(options?: Partial<CompleteWorkflowActivity>) {
    super(options);

    this.type = 'complete-workflow-activity';
    this.name = 'End';
    this.description = 'End the workflow';
    this.displaySubmitCategory=true;

    if (options) {
      Object.assign(this, options);
    }

    this.model = new CompleteWorkflowActivityModel(
      options ? options.model : null
    );
  }

  dereference() {
    this.model.activities = [];
  }
}
